/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Action_Error_CancelInputs */

const vi_pl_action_error_cancel = /** @type {(inputs: Pl_Action_Error_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy phiếu thất bại`)
};

/**

* @param {Pl_Action_Error_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_action_error_cancel = /** @type {((inputs?: Pl_Action_Error_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Action_Error_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_action_error_cancel(inputs)
});